<template>
  <div class="edrea_tm_section" id="services">
    <div class="section_inner">
      <div class="edrea_tm_services">
        <div class="edrea_tm_main_title" style="text-align: center">
          <h3>
            {{ t.services.titleLight }}
            <span class="coloring">{{ t.services.titleColored }}</span>
          </h3>
          <p class="subtitle">{{ t.services.subtitle }}</p>
        </div>

        <ul class="services_list">
          <li v-for="(service, index) in t.services.items" :key="index">
            <div class="list_inner">
              <div class="icon">
                <i :class="service.icon"></i>
              </div>
              <div class="title">
                <h3>{{ service.title }}</h3>
              </div>
              <div class="text">
                <p>{{ service.des }}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { i18n } from "@/i18n";
export default {
  name: `ServicesComponent`,
  computed: {
    t() {
      return i18n.m;
    },
  },
};
</script>

<style scoped>
.edrea_tm_section .section_inner {
  display: block;
  width: 100%;
}

.edrea_tm_services {
  width: 100%;
  flex: 1 1 100%;
}

.edrea_tm_main_title .subtitle {
  color: #a2a2a2;
  font-size: 17px;
  line-height: 1.6;
  max-width: 620px;
  margin: 15px auto 0 auto;
}

.services_list {
  margin: 50px 0 0 0;
  padding: 0;
  list-style: none;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.services_list li {
  margin: 0;
  padding: 0;
  list-style: none;
}

.services_list li .list_inner {
  width: 100%;
  height: 100%;
  padding: 40px 35px;
  background-color: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  box-sizing: border-box;
  transition: all 0.3s ease;
}

.services_list li .list_inner:hover {
  transform: translateY(-8px);
  border-color: var(--main-color);
  background-color: rgba(255, 255, 255, 0.05);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.35);
}

.services_list li .icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: rgba(37, 107, 184, 0.12);
  margin-bottom: 25px;
  transition: all 0.3s ease;
}

.services_list li .list_inner:hover .icon {
  background-color: var(--main-color);
}

.services_list li .icon i {
  font-size: 32px;
  color: var(--main-color);
  transition: all 0.3s ease;
}

.services_list li .list_inner:hover .icon i {
  color: #fff;
}

.services_list li .title h3 {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 14px;
}

.services_list li .text p {
  color: #a2a2a2;
  font-size: 15px;
  line-height: 1.7;
}

@media (max-width: 1040px) {
  .services_list {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .services_list {
    grid-template-columns: 1fr;
  }
}
</style>
